export const DELETE_OFFLINE_ORDER = "DELETE_OFFLINE_ORDER"
export const FETCH_OFFLINE_ORDERS = "FETCH_OFFLINE_ORDERS"
export const ADD_OFFLINE_ORDER = "ADD_OFFLINE_ORDER"
export const REPLACE_OFFLINE_ORDER = "REPLACE_OFFLINE_ORDER"
export const EDIT_OFFLINE_ORDER = "EDIT_OFFLINE_ORDER"
export const DELETE_ALL_OFFLINE_ORDERS = "DELETE_ALL_OFFLINE_ORDERS"